export const COUNT = 'Count';
export const ANY_PAGE_COMPONENT_NAME = 'Any Page';
export const PAGE_LOAD_COUNT = 'PageLoadCount';
